// extracted by mini-css-extract-plugin
export default {"container":"notification_container__CFVV2","icon":"notification_icon__iTStE"};